import { Navigation } from '../components/Navigation'

export function MainLayout({ children }) {
  return (
    <div className="flex flex-col min-h-screen">
      <Navigation />

      {/* Main Content */}
      <main className="flex-1">
        {children}
      </main>

      {/* Footer */}
      <footer className="bg-white text-gray-600 py-5 text-center text-[13px] border-t border-gray-200">
        <p>
          &copy; {new Date().getFullYear()} NexSens Technology, Inc.
          <span className="mx-3 text-gray-300">|</span>
          Questions? Call{' '}
          <a href="tel:9374262703" className="text-[#358ECD] hover:underline">
            937.426.2703
          </a>{' '}
          or email{' '}
          <a href="mailto:info@nexsens.com" className="text-[#358ECD] hover:underline">
            info@nexsens.com
          </a>
        </p>
      </footer>
    </div>
  )
}
